import React from 'react';
import { CheckIcon, FileCheck2Icon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="bg-canvas px-5 py-14 md:py-20" data-id="element-307" data-mp="2wzgn8wo3xm0z">
      <div className="mx-auto max-w-6xl" data-id="element-308" data-mp="2t07xe2w6u8ap">
        <SectionHeading eyebrow="The Complete 6-Volume Professional Blueprint" title="Everything You Need to Build a More Organized Postoperative Wound Assessment Workflow" data-id="element-309" data-mp="2szew3hg00azy" />

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-310" data-mp="2j8k5k0vpyp8p">
          {volumes.map(v => <article key={v.number} className="flex flex-col overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-navy/5" data-id="element-311" data-mp="2e8pjqbqswpui">
              <div className="bg-navy px-5 pb-5 pt-5 text-white" data-id="element-312" data-mp="259u8gl8wgpkc">
                <span className="inline-block rounded-full bg-gold px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-navy" data-id="element-313" data-mp="25c6ogsv3kpur">
                  Volume {v.number}
                </span>
                <h3 className="mt-3 text-xl font-extrabold leading-tight" data-id="element-314" data-mp="333jdxw0j3834">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white/75" data-id="element-315" data-mp="37xnn8lx9ns7d">{v.tagline}</p>
              </div>
              <div className="flex flex-1 flex-col p-5" data-id="element-316" data-mp="2u2uzx1b4x7q8">
                <p className="text-xs font-extrabold uppercase tracking-wider text-teal" data-id="element-317" data-mp="2y5rl8zs27hxv">Inside</p>
                <ul className="mt-3 space-y-2" data-id="element-318" data-mp="3lvvnp3tihbna">
                  {v.inside.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] leading-snug text-navy/80" data-id="element-319" data-mp="3qvgshuvd4e7x">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-320" data-mp="3cue4vdopyvuw" />
                      {item}
                    </li>)}
                </ul>
                <div className="mt-auto pt-5" data-id="element-321" data-mp="21fh81hman2cz">
                  <div className="flex items-start gap-3 rounded-2xl bg-gold-light p-4" data-id="element-322" data-mp="26fdgbt20xfyc">
                    <FileCheck2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-323" data-mp="26d0rcvxum5bs" />
                    <p className="text-sm leading-snug text-navy" data-id="element-324" data-mp="7021xmz4pctf">
                      <span className="font-extrabold" data-id="element-325" data-mp="70tyb00jvekr">Practical Deliverable:</span> {v.deliverable}
                    </p>
                  </div>
                </div>
              </div>
            </article>)}
        </div>

        <SectionCTA label="Unlock All 6 Volumes" data-id="element-326" data-mp="3pdrtyuqb7l94" />
      </div>
    </section>;
}